<template>
  <section ref="slide" :class="{ mounted: mounted === true }"
    class="introslide flex flex-col justify-center min-h-screen bg-workbook-orange pt-12">
    <UContainer>
      <UPageGrid class="headline mt-10 lg:mt-0 text-white">
        <div class="col-span-4 lg:col-span-5">
          <TripleLogo ref="logo" class="mb-0 mt-12 xl:mb-20 triple-logo" />
          <h1 class="mb-12 lg:mb-2 leading text-6xl">
            Four oh four!
          </h1>

        </div>
        <div class="col-span-4 lg:col-span-7 pb-4 lg:pb-0">
          <WorkbookIntroMonitor :text1="'Sorry – this page does not exist.'" :text2="'Please use the menu above to find out what Kudo Sales is all about.'" />
          <p class="text-workbook-black text-center lg:text-right mb-0">Kudo Sales is created by
            <WorkbookIcon name="workbook:hjartat" :color="'black'" />
          </p>
        </div>

      </UPageGrid>
    </UContainer>
  </section>
</template>

<script setup lang="ts">

import { onMounted, ref } from 'vue'
import { loadGsap } from '@/utils/gsap'

const mounted = ref(false)

const slide = ref<HTMLElement | null>(null)

definePageMeta({
  layout: 'default'
})

onMounted(async () => {
  mounted.value = true

  

  const { gsap } = await loadGsap()

  const logoPaths = slide.value?.querySelectorAll('.triple-logo path') as NodeListOf<SVGPathElement> | undefined
  const headline = slide.value?.querySelectorAll('h1') as NodeListOf<HTMLElement> | undefined

  if (logoPaths && logoPaths.length) {
    gsap.to(logoPaths, {
      delay: 0.12,
      x: (i) => i * 2,
      duration: (i) => (i + 1) * 0.2
    })

    const logoTl = gsap.timeline({
      scrollTrigger: {
        trigger: slide.value,
        pin: false,
        markers: false,
        start: 'bottom 98%',
        end: 'bottom 30%',
        scrub: 1.2
      }
    })

    logoTl.add('out')

    logoTl.to(
      logoPaths,
      {
        y: (i) => i * 80,
        x: 0,
        opacity: 0,
        scale: 5,
        duration: (i) => (i + 1) * 0.8
      },
      'out'
    )

    if (headline && headline.length) {
      logoTl.to(
        headline,
        {
          y: 50,
          opacity: 0,
          duration: 0.5,
          stagger: -0.3
        },
        'out'
      )
    }
  }
})



</script>
